export const CALL_STATUSES = [
  { value: "Not called", label: "Not called", group: "active" },
  {
    value: "No answer",
    label: "No answer",
    group: "active",
    reasonLabel: "Call result",
    reasons: [
      "No answer",
      "Switched off",
      "Line busy",
      "Temporarily unreachable",
      "Number disconnected",
      "Invalid number",
      "Wrong number",
    ],
  },
  {
    value: "Follow-up",
    label: "Follow-up",
    group: "follow_up",
    reasonLabel: "Follow-up reason",
    requiresSchedule: true,
    reasons: [
      "Will place order through the app",
      "Requested a callback",
      "Needs time to decide",
      "Will discuss with family",
      "Waiting for salary or payment",
      "Waiting for prescription or document",
      "Needs package information",
      "Needs pricing or discount information",
      "Waiting for product availability",
      "Needs help with payment",
      "Needs help with the app or account",
      "Requested details through WhatsApp",
      "Other",
    ],
  },
  {
    value: "Called",
    label: "Called",
    group: "called",
    reasonLabel: "Call outcome",
    reasons: [
      "Interested",
      "Not interested",
      "Order placed",
      "Order confirmed through the app",
      "Already purchased",
      "Existing customer — no action needed",
      "Not eligible",
      "Duplicate lead",
      "Requested no further calls",
      "Other",
    ],
  },
  {
    value: "Don't Call",
    label: "Don't Call",
    group: "blacklist",
    reasonLabel: "Don't Call reason",
    reasons: [
      "Requested no further calls",
      "Invalid or fraudulent contact",
      "Duplicate customer",
      "Compliance exclusion",
      "Other",
    ],
  },
];

export const getCallStatus = (value) =>
  CALL_STATUSES.find((status) => status.value === value);

export const toApiOutcome = (status, reason) => {
  if (status === "Not called") return "not_called";
  if (status === "No answer") return "no_answer";
  if (status === "Follow-up") return "follow_up";
  if (status === "Don't Call") return "blacklisted";
  if (status === "Called") return reason === "Interested" ? "interested" : "closed";
  return null;
};
